import Support from '../components/Support';
import SigninForm from '../components/forms/SigninForm';
import { ToastContainer, toast } from 'react-toastify';

const SignIn = () => {
  return (
    <div className="col-md-6">
      <div>
        <ToastContainer />
      </div>
      <div className="mb-3 text-center font-weight-bold">
        <h3 className="form-title" style={{ fontSize: '4rem' }}>
          <i className="far fa-user" />
        </h3>
      </div>
      <form>
        <SigninForm />
      </form>
      <Support />
    </div>
  );
};

export default SignIn;
